<div class="background">
  <div class="label-container" [class.small]="small()">
    mit
    <span class="label">
     Aktionsvorteil
    </span>
  </div>
</div>
